var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import qs from 'qs';
import { useSampleOrderColumns } from '../../hooks/useColumns';
import { useFetchSampleOrders } from '../../hooks/useSampleOrder';
import PageLayout from '../atoms/PageLayout';
import MaterialTable from '../MaterialTable';
import { useRoasterCountries } from '../../hooks/useRoasterCountries';
import { useOffice } from '../../hooks/useOffice';
import DownloadSampleOrdersCSVButton from '../organisms/DownloadSampleOrdersCSVButton';
import ImportSampleOrdersButton from '../organisms/ImportSampleOrdersButton';
import { Button } from '@mui/material';
var Toolbox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  a {\n    color: #666;\n  }\n\n  button {\n    margin-left: 5px;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  a {\n    color: #666;\n  }\n\n  button {\n    margin-left: 5px;\n  }\n"])));
var AdminTypicaStockSampleOrdersPage = function () {
    var location = useLocation();
    var t = useTranslation().t;
    var roasterCountryItems = useRoasterCountries().roasterCountryItems;
    var officeItems = useOffice().officeItems;
    var fetchSampleOrders = useFetchSampleOrders({
        type: 'SampleOrder::TypicaStockSampleOrder',
    }).fetchSampleOrders;
    var query = qs.parse(location.search.slice(1));
    var tableRef = React.useRef();
    var reload = React.useCallback(function () {
        if (!tableRef.current)
            return;
        tableRef.current.onQueryChange();
    }, [tableRef]);
    var SampleOrderColumns = useSampleOrderColumns({
        role: 'admin',
        filters: query.filters,
        orderBy: query.orderBy,
        orderDirection: query.orderDirection,
    });
    var defaultFilter = React.useCallback(function (field) {
        var filters = query.filters || {};
        return filters[field];
    }, [query]);
    var renderRoasterCountry = React.useCallback(function (sampleOrder) {
        var code = sampleOrder.roaster.country.code;
        return roasterCountryItems[code];
    }, [roasterCountryItems]);
    var renderRoasterCountryOffice = React.useCallback(function (sampleOrder) {
        var name = sampleOrder.roaster.country.office.name;
        return name;
    }, []);
    var columns = React.useMemo(function () { return [
        SampleOrderColumns.offerListLink,
        SampleOrderColumns.roasterName,
        SampleOrderColumns.storeName,
        SampleOrderColumns.personName,
        {
            field: 'roaster.country.code',
            title: t('params.roaster.country'),
            lookup: roasterCountryItems,
            render: renderRoasterCountry,
            defaultFilter: defaultFilter('roaster.country.code'),
            sorting: false,
        },
        {
            field: 'roaster.country.office.name',
            title: t('params.office.name'),
            lookup: officeItems,
            render: renderRoasterCountryOffice,
            defaultFilter: defaultFilter('roaster.country.office.name'),
            sorting: false,
        },
        SampleOrderColumns.email,
        SampleOrderColumns.status,
        SampleOrderColumns.deliveryCompany,
        SampleOrderColumns.trackingNumber,
        SampleOrderColumns.createdAt,
    ]; }, [
        SampleOrderColumns,
        officeItems,
        defaultFilter,
        renderRoasterCountry,
        roasterCountryItems,
        renderRoasterCountryOffice,
        t,
    ]);
    return (React.createElement(PageLayout, { title: t('pages.adminTypicaStockSampleOrders.title'), actions: React.createElement(Button, { variant: "contained", component: Link, to: "/admin/new_typica_stock_order" }, t('pages.adminNewTypicaStockOrder.title')) },
        React.createElement(Toolbox, null,
            React.createElement(DownloadSampleOrdersCSVButton, { type: "SampleOrder::TypicaStockSampleOrder" }),
            React.createElement(ImportSampleOrdersButton, { onComplete: reload })),
        React.createElement(MaterialTable, { tableRef: tableRef, model: "sampleOrder", columns: columns, data: fetchSampleOrders, options: {
                initialPage: parseInt(query.page) || 0,
                pageSize: parseInt(query.pageSize) || 25,
                paging: true,
                filtering: true,
            }, detailPath: function (sampleOrder) { return "/admin/sample_orders/".concat(sampleOrder.id); } })));
};
export default AdminTypicaStockSampleOrdersPage;
var templateObject_1;
